// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> juniper
// Generated: 2026-10-08T20:12:11.483Z
// Counts: 1 design, 68 content, 42 slot group, 9 collection binding, 7 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home? Start your application online to take the next step toward finding an apartment that fits your needs. Complete the application below to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": "property_bedrooms_range"
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Policy: Pet deposit is refundable up to $200. Pet rent is $25/mo. See your community office for more details.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover comfortable living in Sacramento’s desirable Rosemont neighborhood at Juniper Apartments. Conveniently located near shopping, dining, major freeways, and Sacramento State University, Juniper offers an ideal location that keeps you connected to everything Sacramento has to offer.</p><p>Choose from spacious one-, two-, three-, and four-bedroom apartment and townhome floor plans designed for comfortable everyday living. Enjoy your own private patio or balcony, with select homes featuring the convenience of an in-home washer and dryer.</p><p>Step outside and enjoy Juniper’s tranquil, park-like setting, surrounded by mature trees and inviting green spaces. Relax and unwind at the resort-style swimming pool and spa, gather with friends at the outdoor BBQ area, or enjoy the community garden and dog park. A secure gated community adds another layer of comfort and convenience to life at Juniper.</p><p>Come see why Juniper Apartments is a place you’ll love coming home to. Contact us today to schedule your personalized tour.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>See Juniper Apartments in person.</strong> Tour spacious 1, 2, 3, &amp; 4 bedroom apartments and townhomes set within a tranquil, park-like gated community in Sacramento’s Rosemont area. With 4+ star resident ratings and carefree, affordable living, Juniper is ready to welcome your visit. Schedule your personalized tour today.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166803/01a0f8c9-221f-7498-be1f-ab85f7304521.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two adorable dogs relaxing on pillows on a cozy leather sofa indoors."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-7ace-77ef-a47c-adcd8b2d1dd0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Leasing office entrance with landscaping and red maple tree."
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019f47fb-a02a-75a5-ae60-0bf6e5dc6215.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "An individual diving into a clear blue swimming pool, creating splashes."
      }
    }
  },
  "applynowhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-b81f-706a-aa48-39647272905b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a beige apartment building with balconies and surrounding trees at Juniper Apartments in Sacramento, CA."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-7ace-77ef-a47c-adcd8b2d1dd0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Leasing office entrance with landscaping and red maple tree."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 26,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-d493-74e9-9fd3-0c8425c550f8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with stainless steel appliances, white cabinets, and granite countertops."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa40e-2393-732d-bad5-1d9ab2ec5879.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Couple with dog relaxing on couch with laptop"
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-996d-73bc-8149-ca4f7c0c549a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor patio with wooden pergola and string lights, concrete picnic table, and grills at dusk."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-d493-74e9-9fd3-0c8425c550f8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "White modern kitchen with white cabinets, gray countertops, and stainless steel fridge, dishwasher, and stove under a window at Juniper Apartments in Sacramento, CA."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3e5-7649-74bf-8795-3a6e68f40e58.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d48ac-743f-7449-a177-d8b131fda506.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-8f8f-757d-88dc-1b9c5c0d1a41.webp"
      }
    }
  },
  "floorplanslist.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d48ac-7dfd-775e-bd25-389addfe15d4.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3e5-808a-762a-b97f-80e8ac8232c6.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-b81f-706a-aa48-39647272905b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a beige apartment building with balconies and surrounding trees at Juniper Apartments in Sacramento, CA."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-bd51-720b-b9ec-8881a6b58b92.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of an apartment community pool area with lounge chairs and blue umbrellas at Juniper Apartments in Sacramento, CA."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": 10,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019f47fa-9bec-75f6-bf28-58e42668c648.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Purebred Morkie dogs looking away attentively while lying on gray sofa in daylight"
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019f47fd-cb25-70bf-abb0-9ebabe0992fb.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Golden Retriever relaxing at a luxury heritage hotel entrance in Bikaner, India."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-b81f-706a-aa48-39647272905b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a beige apartment building with balconies and surrounding trees at Juniper Apartments in Sacramento, CA."
      }
    }
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-b30a-774f-9528-c7a4ea447015.webp"
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-d493-74e9-9fd3-0c8425c550f8.webp"
      }
    }
  },
  "propertyoverview.slide_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-8484-741a-984b-4cade8826a2e.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-b81f-706a-aa48-39647272905b.webp"
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-f29c-760b-8b29-3a5b460deb52.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-8e96-705a-b328-301c07e7d186.webp"
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa477-edb2-749f-9742-859781f37170.webp"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-bd51-720b-b9ec-8881a6b58b92.webp"
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-7ace-77ef-a47c-adcd8b2d1dd0.webp"
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-b600-712a-8e1d-df7af38c826b.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-99a4-72e9-8eb9-ee471ff64fd2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Leasing office building entrance with landscaping."
      }
    }
  },
  "reviewshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166809/019fa40e-2393-732d-bad5-1d9ab2ec5879.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Couple with dog relaxing on couch with laptop"
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-b81f-706a-aa48-39647272905b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a beige apartment building with balconies and surrounding trees at Juniper Apartments in Sacramento, CA."
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166809/019fa40e-2393-732d-bad5-1d9ab2ec5879.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Couple relaxing on a couch with their dog and a laptop in a bright apartment."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": [
      "custom_2dbebfd4-9f62-4081-b8f7-1243cd4e61b9",
      "custom_4429b61f-84fe-47b9-a627-0a29654aa833",
      "custom_ae1e79e7-4d65-4b7d-ae66-e84c446a49bf",
      "custom_6fcc7e26-0dd6-4fab-91ad-fe205df907ec",
      "custom_ef2a5a97-e8ec-4d6c-a498-2b1bdda0b1a1",
      "custom_5597b0d9-43e7-4828-8220-c2474b69a0eb",
      "custom_f6f4e9da-0952-49f0-b1ba-7452cdf4731d",
      "custom_7fe8cdf7-a83a-48bf-b9ac-4716dbd503d5",
      "custom_90bfe766-d5f5-4e91-a986-b7bad92d62d1",
      "custom_540d1e10-3719-44ca-abd4-b8780a7b525c",
      "custom_ed3f76a5-0aee-4c1a-b228-047e561d2ad3",
      "custom_1f1aed27-5886-4502-9016-13d3cdf001dc",
      "custom_437fc05a-d4ba-4697-a843-8336b322b6a8",
      "custom_0460baef-96bd-42b2-ac4b-bb47b6c0f60f",
      "custom_a82b21ef-9d5b-4b40-9661-963418f7e431",
      "custom_143e0b75-9d38-4567-80aa-eb3160195895",
      "custom_4a55c675-884b-447b-a810-c72e680ac615",
      "custom_5c843b50-c609-4d14-b9d4-5c2e83479394",
      "custom_d15855b5-aa13-4a95-95d6-548aac791484",
      "custom_fd72dabb-eab2-4298-b111-6481382174d6",
      "custom_b5f3dbd6-5849-48ea-a000-0284f05e96d3"
    ],
    "orderedIds": [
      "custom_72412240-9cf0-4601-a2e6-fa3070d97bd4",
      "custom_fcbfb7e5-6623-4f11-88dd-2e3bc5060e9e",
      "custom_590da125-e80e-4a9e-8568-398b70d4a576",
      "custom_9390c6a9-6033-4abf-994a-bcb15ab08078",
      "custom_13c17ced-3a41-49ed-a939-97b627611dae",
      "custom_6edcd302-5bd4-4757-bcd9-6393c498fad3",
      "custom_ca92327d-f1dc-4909-a890-da0ef8984ffa",
      "custom_fd72dabb-eab2-4298-b111-6481382174d6",
      "custom_b5f3dbd6-5849-48ea-a000-0284f05e96d3",
      "custom_d15855b5-aa13-4a95-95d6-548aac791484",
      "custom_8d1edb37-950c-4676-8413-69c1976fbc16",
      "custom_4429b61f-84fe-47b9-a627-0a29654aa833",
      "custom_ae1e79e7-4d65-4b7d-ae66-e84c446a49bf",
      "custom_6fcc7e26-0dd6-4fab-91ad-fe205df907ec",
      "custom_f6f4e9da-0952-49f0-b1ba-7452cdf4731d",
      "custom_7fe8cdf7-a83a-48bf-b9ac-4716dbd503d5",
      "custom_4a55c675-884b-447b-a810-c72e680ac615",
      "custom_90bfe766-d5f5-4e91-a986-b7bad92d62d1",
      "custom_143e0b75-9d38-4567-80aa-eb3160195895",
      "custom_2dbebfd4-9f62-4081-b8f7-1243cd4e61b9",
      "custom_1f1aed27-5886-4502-9016-13d3cdf001dc",
      "custom_437fc05a-d4ba-4697-a843-8336b322b6a8",
      "custom_5c843b50-c609-4d14-b9d4-5c2e83479394",
      "custom_a82b21ef-9d5b-4b40-9661-963418f7e431",
      "custom_0460baef-96bd-42b2-ac4b-bb47b6c0f60f",
      "custom_ed3f76a5-0aee-4c1a-b228-047e561d2ad3",
      "custom_540d1e10-3719-44ca-abd4-b8780a7b525c",
      "custom_5597b0d9-43e7-4828-8220-c2474b69a0eb",
      "custom_ef2a5a97-e8ec-4d6c-a498-2b1bdda0b1a1"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentItems": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_68a3fd99-60a6-43de-8276-b9da977e869e",
      "custom_b06ceea4-5d16-4c1f-afe2-b37e95ca1e9f",
      "custom_139064ed-5520-45f2-bd19-42522a843415",
      "custom_50fea8ee-3754-4634-a15c-9a6c93ee2691",
      "custom_fd94316f-04a7-4249-842d-e717019d8360",
      "custom_c5e3816f-01ae-4af8-85a1-43d18153909a",
      "custom_21f9bbb0-d88c-4edf-b231-a73af320af3d",
      "custom_0b7442b3-12a1-46c9-84ba-b34ea78aa643",
      "custom_ff0e6320-eea7-4ec8-8dc2-11625d3de2cc",
      "custom_ea2cd684-95bd-4fff-b8af-b376bc931bb5",
      "custom_e0b2f14b-5685-4b1e-87c9-e323bae3a31a",
      "custom_26b8f794-dbb1-4c2e-844c-0c3f5b07c678",
      "custom_a1388fb5-7e26-4d7e-bef1-fb5e1ad36417"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityItems": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      10,
      9,
      13
    ],
    "ordering": [
      0,
      17,
      14,
      15,
      2,
      16,
      12,
      11,
      18,
      1,
      3,
      4,
      6,
      5,
      8,
      7,
      9,
      10,
      13
    ],
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": 9,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      5,
      0,
      7,
      6,
      10,
      8
    ],
    "ordering": [
      4,
      1,
      3,
      14,
      13,
      15,
      16,
      12,
      17,
      8,
      10,
      2,
      9,
      0,
      5,
      6,
      7,
      11
    ],
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_0460baef-96bd-42b2-ac4b-bb47b6c0f60f",
      "custom_2dbebfd4-9f62-4081-b8f7-1243cd4e61b9",
      "custom_5c843b50-c609-4d14-b9d4-5c2e83479394",
      "custom_ed3f76a5-0aee-4c1a-b228-047e561d2ad3",
      "custom_540d1e10-3719-44ca-abd4-b8780a7b525c",
      "custom_13c17ced-3a41-49ed-a939-97b627611dae",
      "custom_90bfe766-d5f5-4e91-a986-b7bad92d62d1",
      "custom_143e0b75-9d38-4567-80aa-eb3160195895",
      "custom_1f1aed27-5886-4502-9016-13d3cdf001dc"
    ],
    "orderedIds": [
      "custom_590da125-e80e-4a9e-8568-398b70d4a576",
      "custom_4429b61f-84fe-47b9-a627-0a29654aa833",
      "custom_ca92327d-f1dc-4909-a890-da0ef8984ffa",
      "custom_5c843b50-c609-4d14-b9d4-5c2e83479394",
      "custom_437fc05a-d4ba-4697-a843-8336b322b6a8",
      "custom_6fcc7e26-0dd6-4fab-91ad-fe205df907ec",
      "custom_7fe8cdf7-a83a-48bf-b9ac-4716dbd503d5",
      "custom_f6f4e9da-0952-49f0-b1ba-7452cdf4731d",
      "custom_fcbfb7e5-6623-4f11-88dd-2e3bc5060e9e",
      "custom_4a55c675-884b-447b-a810-c72e680ac615",
      "custom_9390c6a9-6033-4abf-994a-bcb15ab08078",
      "custom_1f1aed27-5886-4502-9016-13d3cdf001dc",
      "custom_90bfe766-d5f5-4e91-a986-b7bad92d62d1",
      "custom_ae1e79e7-4d65-4b7d-ae66-e84c446a49bf",
      "custom_143e0b75-9d38-4567-80aa-eb3160195895",
      "custom_2dbebfd4-9f62-4081-b8f7-1243cd4e61b9",
      "custom_13c17ced-3a41-49ed-a939-97b627611dae",
      "custom_a82b21ef-9d5b-4b40-9661-963418f7e431",
      "custom_6edcd302-5bd4-4757-bcd9-6393c498fad3",
      "custom_0460baef-96bd-42b2-ac4b-bb47b6c0f60f",
      "custom_ed3f76a5-0aee-4c1a-b228-047e561d2ad3",
      "custom_72412240-9cf0-4601-a2e6-fa3070d97bd4",
      "custom_fd72dabb-eab2-4298-b111-6481382174d6",
      "custom_540d1e10-3719-44ca-abd4-b8780a7b525c",
      "custom_5597b0d9-43e7-4828-8220-c2474b69a0eb",
      "custom_ef2a5a97-e8ec-4d6c-a498-2b1bdda0b1a1",
      "custom_d15855b5-aa13-4a95-95d6-548aac791484",
      "custom_b5f3dbd6-5849-48ea-a000-0284f05e96d3"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.apartment_amenities": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_68a3fd99-60a6-43de-8276-b9da977e869e",
      "custom_b06ceea4-5d16-4c1f-afe2-b37e95ca1e9f",
      "custom_139064ed-5520-45f2-bd19-42522a843415",
      "custom_ff0e6320-eea7-4ec8-8dc2-11625d3de2cc",
      "custom_50fea8ee-3754-4634-a15c-9a6c93ee2691",
      "custom_21f9bbb0-d88c-4edf-b231-a73af320af3d",
      "custom_c5e3816f-01ae-4af8-85a1-43d18153909a",
      "custom_0b7442b3-12a1-46c9-84ba-b34ea78aa643",
      "custom_ea2cd684-95bd-4fff-b8af-b376bc931bb5",
      "custom_e0b2f14b-5685-4b1e-87c9-e323bae3a31a",
      "custom_fd94316f-04a7-4249-842d-e717019d8360",
      "custom_26b8f794-dbb1-4c2e-844c-0c3f5b07c678",
      "custom_a1388fb5-7e26-4d7e-bef1-fb5e1ad36417"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.community_amenities": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_43fab935-af31-4245-9610-89259a3588a7",
      "custom_733171b8-eb0e-4fcf-81ff-d7ceb36f9ebe",
      "custom_f6e35253-0909-492e-817b-d493e047818f",
      "custom_7bbb7791-1ec0-43a8-9f1f-a3210414e7e8",
      "custom_3d0e4794-bff2-4615-9c39-75a561b0ac45",
      "custom_e0c51d65-729d-4234-9d55-3984e676c297",
      "custom_19e116b7-017c-4c76-8858-5956faf68248",
      "custom_cbad83cd-e37e-41af-afdd-ac184d69964b",
      "custom_47479578-cb92-46cf-b623-5166caba2141",
      "custom_240eb4a1-9dca-47ad-9c47-618c42f55aad",
      "custom_d53ac705-fe41-4ca5-bb74-bfbc6deebe96",
      "custom_9fdba728-42d8-4a9d-a4d1-66f0d296e194",
      "custom_92c37715-ecf1-4996-b1c4-e90f8ef9b408",
      "custom_d578d972-b270-457c-9690-e9b23321121a",
      "custom_aa643cfa-4e2c-4f43-8266-c1afc7942876",
      "custom_bc84c57b-cb70-45f1-b3dc-801a92f10008",
      "custom_e6ccfa00-72dc-401e-8ffc-f5891b58bf01",
      "custom_cd5ed476-94e5-4f86-a0dd-a6a853d26d54",
      "custom_3539be22-1e93-4f83-ac89-94204a6bfc0a"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.ReviewsCallout": {
    "properties": {
      "display": "none"
    }
  }
};
